import Avatar from '@mui/material/Avatar';
import React, { FC, useMemo } from 'react';

import { useGetUser } from 'core/hooks/useGetUser';

interface ICustomAvatarProps {
	firstName?: string;
	lastName?: string;
	avatarLink?: string;
	stylesObj?: Record<string, string>;
}

export const CustomAvatar: FC<ICustomAvatarProps> = ({
	firstName = '',
	lastName = '',
	avatarLink,
	stylesObj = {},
}) => {
	const { user } = useGetUser();

	let initials = '';

	if (firstName && lastName) {
		initials = firstName.charAt(0);
	} else {
		initials = user && user.firstName ? user.firstName.charAt(0) : '';
	}

	const parsedAvatarLink = useMemo(() => {
		if (avatarLink === undefined) return user?.avatarLink;
		if (avatarLink === null) return '';

		return avatarLink;
	}, [avatarLink]);

	return (
		<Avatar sx={{ bgcolor: '#1976d2', ...stylesObj }} src={parsedAvatarLink}>
			{initials}
		</Avatar>
	);
};
